<template>
	<div class="homepopup">
		<div class="title">{{title}}</div>
		<div class="text" v-html="txt">
		</div>
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'homepopup',
		props:{
			title:{
				default:''
			},
			txt:{
				default:''
			}
		}
	}
</script>

<style scoped>
	.homepopup{
		position: absolute;
		right: 2rem;
		top: 2rem;
		bottom: 2rem;
		left: 2rem;
		overflow-y: auto;
	}
	.homepopup .title{
		height: 5rem;
		text-align: center;
		font-size: 2.2rem;
		line-height: 5rem;
		font-family: 'STXingkai';
		border-bottom: 1px dashed #5f3519;
		color: #5f3519;
		margin: 1rem;
		letter-spacing: 0.5rem;
	}
	.homepopup .text{
		color: #5f3519;
		line-height: 2.5rem;
		font-size: 1.142857rem;
		text-indent: 2rem;
		padding: 1rem;
		letter-spacing: 0.2rem;
	}
	.homepopup .text >>> p img{
		max-width: calc(100% - 1rem) !important;
		height: auto;
		display: block;
		border: 0.5rem solid #FFFFFF;
	}
</style>
